import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Breadcrumb, BackdropCircular} from 'components';
import {
  Card,
  Typography,
  Divider,
  Grid,
  Switch,
  TextField,
  Button
} from '@material-ui/core';
import {
  getHomepageWelcomeBlockConfigsApi,
  saveHomepageWelcomeBlockConfigsApi
} from 'api';
import {
  changeHomepageWelcomeBlockConfigConfig
} from 'redux/actions/store_configs';


const WelcomeBlock = () => {
  const dispatch = useDispatch();
  const {
    homepageWelcomeBlockConfigs = [],
    loadingHomepageWelcomeBlockConfigs,
    savingHomepageWelcomeBlockConfigs
  } = useSelector((state) => state.store_configs);
  const loading = loadingHomepageWelcomeBlockConfigs || savingHomepageWelcomeBlockConfigs;

  useEffect(() => {
    if (!homepageWelcomeBlockConfigs.length) {
      getHomepageWelcomeBlockConfigsApi({dispatch});
    }
  }, []);

  const configValue = (path) => {
    return !homepageWelcomeBlockConfigs.length
      ? ''
      : homepageWelcomeBlockConfigs.find((config) => config.path === path).value;
  };

  const isBlockEnabled = configValue('store_info/welcome/is_welcome_block_enabled');
  const headingValue = configValue('store_info/welcome/welcome_block_heading');
  const aboveHeadingValue = configValue('store_info/welcome/welcome_block_above_heading');
  const contentValue = configValue('store_info/welcome/welcome_block_content');

  const handleChange = (event) => {
    const {name, checked, type, value} = event.target;
    dispatch(changeHomepageWelcomeBlockConfigConfig(name, checked, type, value));
  };

  const handleSave = () => {
    saveHomepageWelcomeBlockConfigsApi({dispatch, configs: homepageWelcomeBlockConfigs});
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <Breadcrumb
        routeSegments={[
          { name: 'Settings', path: '/settings#go_live_requirements' },
          { name: 'UI Configurations', path: '/settings#UI_configurations' },
          { name: 'Homepage Settings', path: '/configurations/homepage'},
          { name: 'Welcome Block'}
        ]}
      />
      <div className="m-10">
        <Card className="p-8">
          <Typography variant="h4" className="mb-8">Welcome Block</Typography>
          <Divider className="mb-8" />
          <Grid container spacing={3} className="mb-8">
            <Grid item xs={12} sm={2} className="my-2 ml-4">Enable</Grid>
            <Grid item xs={12} sm={9}>
              <Switch
                color="primary"
                name={'store_info/welcome/is_welcome_block_enabled'}
                checked={isBlockEnabled == 1}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={2} className="ml-4">Above Heading</Grid>
            <Grid item xs={12} sm={9}>
              <TextField
                fullWidth
                variant="outlined"
                name={'store_info/welcome/welcome_block_above_heading'}
                label="Text"
                value={aboveHeadingValue}
                onChange={handleChange}
                inputProps={{
                  shrink: true
                }}
              />
            </Grid>
            <Grid item xs={12} sm={2} className="ml-4">Heading</Grid>
            <Grid item xs={12} sm={9}>
              <TextField
                fullWidth
                variant="outlined"
                name={'store_info/welcome/welcome_block_heading'}
                label="Text"
                value={headingValue}
                onChange={handleChange}
                inputProps={{
                  shrink: true
                }}
              />
            </Grid>
            <Grid item xs={12} sm={2} className="ml-4">Content</Grid>
            <Grid item xs={12} sm={9}>
              <TextField
                fullWidth
                multiline
                rows={7}
                variant="outlined"
                name={'store_info/welcome/welcome_block_content'}
                label="Text"
                value={contentValue}
                onChange={handleChange}
                inputProps={{
                  className: 'p-0',
                  shrink: true
                }}
              />
            </Grid>
          </Grid>
        </Card>
        <div className="flex justify-end">
          <Button
            variant="contained"
            color="primary"
            className="my-10"
            onClick={handleSave}
          >
            Save Configurations
          </Button>
        </div>
      </div>
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default WelcomeBlock;
